"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.USER_AGENT = exports.SPEED_START_TIME = exports.ERROR_FILTER_LIST = void 0;

var _get2 = _interopRequireDefault(require("@baidu/mvideo-tool/lib/get"));

var _window, _window$navigator;

// 性能初始时间点
var SPEED_START_TIME = (0, _get2.default)(performance, 'timing.navigationStart', +new Date()); // 当前UA

exports.SPEED_START_TIME = SPEED_START_TIME;
var USER_AGENT = ((_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) || ''; // js异常过滤

exports.USER_AGENT = USER_AGENT;
var ERROR_FILTER_LIST = ['script error.', 'Uncaught ReferenceError: WeixinJSBridge is not defined', 'Uncaught TypeError: window.syncCallback is not a function', 'TypeError: window.syncCallback is not a function.', 'ReferenceError: Can\'t find variable: _Box_'];
exports.ERROR_FILTER_LIST = ERROR_FILTER_LIST;